// Reads an uploaded .csv or .xlsx in the browser into rows (array of arrays). No libraries:
// .xlsx is a ZIP; entries are inflated with the browser's DecompressionStream('deflate-raw').
export function parseCsv(text) {
  const rows = []; let row = []; let cell = ''; let q = false;
  const t = String(text || '').replace(/^\uFEFF/, '');
  for (let i = 0; i < t.length; i++) {
    const ch = t[i];
    if (q) { if (ch === '"') { if (t[i + 1] === '"') { cell += '"'; i++; } else q = false; } else cell += ch; continue; }
    if (ch === '"') q = true;
    else if (ch === ',') { row.push(cell); cell = ''; }
    else if (ch === '\n' || ch === '\r') { if (ch === '\r' && t[i + 1] === '\n') i++; row.push(cell); rows.push(row); row = []; cell = ''; }
    else cell += ch;
  }
  if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
  return rows.filter((r) => r.some((c) => String(c).trim() !== ''));
}

async function unzip(buf) {
  const dv = new DataView(buf); const files = {};
  let eocd = -1;
  for (let i = buf.byteLength - 22; i >= Math.max(0, buf.byteLength - 70000); i--) if (dv.getUint32(i, true) === 0x06054b50) { eocd = i; break; }
  if (eocd < 0) throw new Error('This does not look like an .xlsx file.');
  let p = dv.getUint32(eocd + 16, true); const n = dv.getUint16(eocd + 10, true);
  for (let k = 0; k < n; k++) {
    const method = dv.getUint16(p + 10, true); const size = dv.getUint32(p + 20, true);
    const nameLen = dv.getUint16(p + 28, true); const extra = dv.getUint16(p + 30, true); const comment = dv.getUint16(p + 32, true);
    const off = dv.getUint32(p + 42, true);
    const name = new TextDecoder().decode(new Uint8Array(buf, p + 46, nameLen));
    files[name] = { method, size, off };
    p += 46 + nameLen + extra + comment;
  }
  const read = async (name) => {
    const f = files[name]; if (!f) return null;
    const start = f.off + 30 + dv.getUint16(f.off + 26, true) + dv.getUint16(f.off + 28, true);
    const data = new Uint8Array(buf, start, f.size);
    if (f.method === 0) return new TextDecoder().decode(data);
    if (typeof DecompressionStream === 'undefined') throw new Error('This browser cannot read .xlsx files. Save as .csv and try again.');
    const out = new Blob([data]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
    return new Response(out).text();
  };
  return { files, read };
}

const colIndex = (ref) => { const m = /^([A-Z]+)/.exec(ref || ''); if (!m) return -1; let n = 0; for (const ch of m[1]) n = n * 26 + (ch.charCodeAt(0) - 64); return n - 1; };

export async function parseXlsx(buf) {
  const z = await unzip(buf);
  const dp = new DOMParser();
  const ssXml = await z.read('xl/sharedStrings.xml');
  const shared = ssXml ? [...dp.parseFromString(ssXml, 'application/xml').getElementsByTagName('si')].map((si) => [...si.getElementsByTagName('t')].map((t) => t.textContent).join('')) : [];
  const sheetName = Object.keys(z.files).filter((f) => /^xl\/worksheets\/sheet\d+\.xml$/.test(f)).sort()[0];
  if (!sheetName) throw new Error('No sheet found in this file.');
  const doc = dp.parseFromString(await z.read(sheetName), 'application/xml');
  const rows = [];
  for (const r of doc.getElementsByTagName('row')) {
    const row = [];
    for (const c of r.getElementsByTagName('c')) {
      const i = colIndex(c.getAttribute('r')); const t = c.getAttribute('t');
      const v = c.getElementsByTagName('v')[0]; const is = c.getElementsByTagName('is')[0];
      const val = t === 's' ? shared[Number(v && v.textContent)] : t === 'inlineStr' ? (is ? is.textContent : '') : v ? v.textContent : '';
      row[i >= 0 ? i : row.length] = val == null ? '' : String(val);
    }
    rows.push(Array.from(row, (x) => x || ''));
  }
  return rows.filter((r) => r.some((c) => String(c).trim() !== ''));
}

export async function readSheetFile(file) {
  if (/\.csv$/i.test(file.name) || file.type === 'text/csv') return parseCsv(await file.text());
  if (/\.xlsx$/i.test(file.name)) return parseXlsx(await file.arrayBuffer());
  throw new Error('Please upload a .xlsx or .csv file.');
}
